import memoize from 'lodash/memoize';
import { BeaconEventType } from 'api/beacon';
import { CustomEventWithUnitId, WidgetState } from './types';

export const customEventBindingsSelector = memoize((state: WidgetState) => {
  const { unitOrder, units } = state;

  return unitOrder?.reduce(
    (bindingMap, unitId) => {
      const unit = units?.[unitId];
      const customEvents = unit?.customEvents;

      customEvents?.forEach((e) => {
        const bindings = bindingMap[e.bindEventType] ?? [];
        bindings.push({ ...e, unitId });
        bindingMap[e.bindEventType] = bindings;
      });

      return bindingMap;
    },
    {} as Record<BeaconEventType, CustomEventWithUnitId[]>,
  );
});
